<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh-left" id="fore"><span class="epub-b">Foreword</span></p>
<p class="tni">A playwright should let his work speak for itself, but in the ninth year of running a theatre company, and my nineteenth of writing plays in the West Indies, I began as a commemorative essay the lengthy prologue that follows. This essay should not be considered either as an apologia or a manifesto, something to pummel the reader’s sympathy for the flaws in the plays. It merely tries to re-create the experience of a playwright with the company to which his plays became committed.</p>
<p class="txs">I cannot list all who have helped over the years but I must acknowledge my gratitude to the Rockefeller Foundation for a three-year grant; to Dr. John Harrison, Dr. Gerald Freund, Mr. John Gillespie, Mr. Henri Salvatori, Mr. George White, Mr. Dale Wasserman, Mr. Derek Knight, and Mr. Errol Barrow; and to my wife, Margaret, for sharing in all the irritating practicalities of play production.</p>
<p class="ausig">D. W.</p>
<p class="tni"><span class="epub-i">Trinidad</span></p>
<p class="tni"><span class="epub-i">September 1970</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// foreword.vue?ba0b0c5e